import { createSlice } from '@reduxjs/toolkit';
import { downloadAdminExportXlsx, getAdminExportData } from './adminExport.actions';

const initialState = {
  adminExportData: [],
  adminExportMetaData: {},

  isLoadingAdminExport: false,
  isLoadingDownloadAdminExport: false,
};

const adminExportSlice = createSlice({
  name: 'adminExport',
  initialState,
  reducers: {
    clearAdminExportState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminExportData.pending, (state) => {
      state.isLoadingAdminExport = true;
    });
    builder.addCase(getAdminExportData.fulfilled, (state, action) => {
      state.adminExportData = action.payload?.items || [];
      state.adminExportMetaData = action.payload?.meta || {};
      state.isLoadingAdminExport = false;
    });
    builder.addCase(getAdminExportData.rejected, (state) => {
      state.isLoadingAdminExport = false;
    });

    builder.addCase(downloadAdminExportXlsx.pending, (state) => {
      state.isLoadingDownloadAdminExport = true;
    });
    builder.addCase(downloadAdminExportXlsx.fulfilled, (state) => {
      state.isLoadingDownloadAdminExport = false;
    });
    builder.addCase(downloadAdminExportXlsx.rejected, (state) => {
      state.isLoadingDownloadAdminExport = false;
    });
  },
});

export const { clearAdminExportState } = adminExportSlice.actions;

export default adminExportSlice.reducer;
